module.exports = __webpack_public_path__ + "media/tick4.6ddb5279.webm";